module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header header-flex"
  }, [_c('h2', [_vm._v("Lista de Submissões")]), _vm._v(" "), (_vm.statusKey === 'em_avaliacao' && this.listStore.listData.length) ? _c('el-button', {
    attrs: {
      "type": "success",
      "disabled": !_vm.allPapersEvaluated && true
    },
    on: {
      "click": _vm.onFinishPapersWeb
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" "), _c('span', [_vm._v("Finalizar Todas Avaliações")])]) : _vm._e()], 1), _vm._v(" "), _c('ListMain', [_c('div', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-card', {
    staticClass: "el-card__search_list box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onFilter
    }
  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.onFilterClean
    }
  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Código"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Filtrar por Código"
    },
    model: {
      value: (_vm.filters.id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "id", $$v)
      },
      expression: "filters.id"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Código")]), _vm._v(" "), _c('th', [_vm._v("Autor")]), _vm._v(" "), _c('th', [_vm._v("Data da Submissão")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Avaliadores In Loco")]), _vm._v(" "), (_vm.isOnEvaluation) ? _c('th', {
    attrs: {
      "width": "140"
    }
  }, [_vm._v("Avaliações")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "btn-actions"
  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.registration.person.pessoa ? item.registration.person.pessoa.nome : 'Cadastro não encontrado no Segue') + " (" + _vm._s(item.registration.person.ref_pessoa) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.date_submitted)))]), _vm._v(" "), _c('td', [_c('div', [_c('paper-status-label', {
      attrs: {
        "status-id": item.paper_status_id,
        "status-key": item.status.key,
        "status-name": item.status.name
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "small"
    }, [_vm._v("Última Atualização: " + _vm._s(_vm._f("dateTimeEnToBr")(item.last_modified)))])]), _vm._v(" "), _c('td', [_c('paper-evaluations-label', {
      attrs: {
        "evaluations": _vm.getTotalAvaliacoesInloco(item.reviews)
      }
    })], 1), _vm._v(" "), (_vm.isOnEvaluation && item.event_paper_type.evaluation_type) ? _c('td', [_c('el-progress', {
      attrs: {
        "percentage": _vm.getEvaluationProgress(item),
        "stroke-width": 18,
        "text-inside": true
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isOnEvaluation && !item.event_paper_type.evaluation_type) ? _c('td', [_vm._v("\n                        Avaliações fora do período\n                    ")]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "default",
        "disabled": !_vm.canBeApproved(item),
        "size": "mini",
        "title": _vm.canBeApproved(item) ? 'Visualizar Trabalho' : 'Trabalho indisponível'
      },
      on: {
        "click": function($event) {
          _vm.showPaper(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _vm._v(" "), (item.file) ? _c('a', {
      staticClass: "el-button el-button--info el-button--mini",
      attrs: {
        "href": item.file.download_file_path,
        "target": "_blank",
        "title": "Baixar arquivo"
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e()], 1)])
  }))])]) : _vm._e()]), _vm._v(" "), (_vm.isPaperVisible) ? _c('div', {
    attrs: {
      "id": "paper-content"
    }
  }, [_c('paper-show', {
    attrs: {
      "model": _vm.paper,
      "load-list": _vm.loadList
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cf1c09d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/show/Papers.vue
// module id = 785
// module chunks = 2